export default __webpack_public_path__ + "static/media/banner-arrow.404b3d60.404b3d60.svg";